<template>
  <div>
    <!-- Video Header (Volledige breedte) -->
    <div
      class="w-full h-[60vh] z-[-1] overflow-hidden absolute top-0 left-0 clip-mountains"
    >
      <video
        class="w-full h-[60vh] object-cover"
        autoplay
        loop
        muted
        playsinline
        style="object-position: center"
      >
        <source src="/public/videos/background.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div
        class="absolute top-2/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center"
      >
        <div class="text-5xl text-gray-400 font-bold mb-4">ToSoTravels</div>
      </div>
    </div>

    <!-- Content Wrapper
    <div class="max-w-7xl mx-auto p-6 mt-[60vh]">
      <TextDivider :mainText="$t('ourTrips')" :subText="$t('seeOurTrips')" />
      <BlogPostGrid />
    </div> -->
    <!-- Content vacation Wrapper -->
    <div class="max-w-7xl mx-auto p-6 mt-[60vh]">
      <TextDivider
        :mainText="$t('ourVacations')"
        :subText="$t('seeOurVacations')"
      />
      <PostGrid :postType="'vacation'" :collection="'vacation'" />
    </div>
    <!-- Content day-trip Wrapper -->
    <div class="max-w-7xl mx-auto p-6">
      <TextDivider
        :mainText="$t('ourDayTrips')"
        :subText="$t('seeOurDayTrips')"
      />
      <PostGrid :postType="'day-trip'" :collection="'dayTrip'" />
    </div>
    <!-- Content review Wrapper -->
    <div class="max-w-7xl mx-auto p-6">
      <TextDivider
        :mainText="$t('ourReviews')"
        :subText="$t('seeOurReviews')"
      />
      <PostGrid :postType="'review'" :collection="'review'" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useHead, defineAsyncComponent, useI18n } from "#imports";

const PostGrid = defineAsyncComponent(
  () => import("~/components/PostGrid.vue")
);

// Haal de vertaling op voor de beschrijving en titel
const { t } = useI18n();

// Zet de meta-gegevens voor deze pagina
useHead({
  title: t("meta.title"), // Specifieke titel voor de pagina, afhankelijk van de taal
  meta: [
    { name: "description", content: t("meta.description") }, // Beschrijving voor de pagina
    { property: "og:title", content: t("meta.title") }, // Open Graph titel
    { property: "og:description", content: t("meta.description") }, // Open Graph beschrijving
    { property: "og:image", content: "toso-logo.png" }, // Open Graph afbeelding
    { property: "og:url", content: "https://www.tosotravels.com" }, // Open Graph URL
    { name: "twitter:card", content: "summary_large_image" }, // Twitter card-instellingen
    { name: "twitter:creator", content: "@yourTwitterHandle" }, // Twitter creator handle
  ],
  script: [
    {
      type: "application/ld+json",
      innerHTML: JSON.stringify({
        "@context": "http://schema.org",
        "@type": "Organization", // Aangepast voor de organisatie van ToSoTravels
        name: "ToSoTravels",
        url: "https://www.tosotravels.com",
        description: t("meta.description"),
        logo: {
          "@type": "ImageObject",
          url: "https://www.tosotravels.com/assets/logo/toso_logo.png",
        },
      }),
    },
  ],
});
</script>

<style scoped>
.clip-mountains {
  clip-path: polygon(
    0% 90%,
    2% 85%,
    5% 95%,
    8% 88%,
    12% 92%,
    15% 90%,
    20% 98%,
    25% 93%,
    30% 92%,
    35% 97%,
    40% 100%,
    45% 96%,
    50% 90%,
    55% 97%,
    60% 100%,
    65% 93%,
    70% 92%,
    75% 95%,
    80% 98%,
    85% 94%,
    90% 92%,
    92% 96%,
    95% 98%,
    97% 92%,
    100% 90%,
    100% 0%,
    0% 0%
  );
}
</style>
